import React, { useEffect, useRef } from "react";
import storyImage from "../assets/images/anh12.jpg";
import "./Story.css"; // Changed filename to avoid conflicts

function Story() {
  // Renamed component to avoid conflicts
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("wedding-visible"); // Added prefix
            const animatedElements = entry.target.querySelectorAll(
              ".wedding-text-animate, .wedding-img, .wedding-heart-title"
            );
            animatedElements.forEach((el) => {
              el.classList.remove("wedding-animate-active");
              void el.offsetWidth; // Trigger reflow
              el.classList.add("wedding-animate-active");
            });
          } else {
            entry.target.classList.remove("wedding-visible");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  // Function to create floating hearts
  const FloatingHearts = () => {
    const hearts = [];
    for (let i = 0; i < 15; i++) {
      hearts.push(
        <div
          key={i}
          className="wedding-floating-heart"
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${Math.random() * 10 + 5}s`,
            animationDelay: `${Math.random() * 5}s`,
          }}
        >
          ❤️
        </div>
      );
    }
    return <div className="wedding-hearts-container">{hearts}</div>;
  };

  return (
    <div
      id="wedding-story"
      className="wedding-story wedding-section-padding"
      ref={sectionRef}
    >
      <FloatingHearts />
      <div className="wedding-container">
        <div className="wedding-row">
          <div className="wedding-col-md-5 wedding-mb-30">
            <div className="wedding-story-img wedding-animate-box">
              <div className="wedding-img">
                <img src={storyImage} className="wedding-img-fluid" alt="" />
                <div className="wedding-image-heart wedding-heart-top-left">
                  ❤️
                </div>
                <div className="wedding-image-heart wedding-heart-top-right">
                  ❤️
                </div>
                <div className="wedding-image-heart wedding-heart-bottom-left">
                  ❤️
                </div>
                <div className="wedding-image-heart wedding-heart-bottom-right">
                  ❤️
                </div>
              </div>
              <div className="wedding-story-img-2 wedding-story-wedding"></div>
            </div>
          </div>
          <div className="wedding-col-md-7 wedding-animate-box">
            <div className="wedding-title-container">
              <h4 className="wedding-story-subtitle wedding-heart-title wedding-text-animate">
                Our love<span className="wedding-heart-pulse">❤️</span>
              </h4>
            </div>
            <h3 className="wedding-story-title wedding-text-animate">
              Sweet love
            </h3>
            <p className="wedding-text-animate">
              Tình yêu đích thực là khi bạn tìm thấy người khiến trái tim mình
              bình yên và hạnh phúc. Yêu đúng người không có nghĩa là mọi thứ
              đều hoàn hảo, mà là khi cả hai cùng nhau vượt qua những khó khăn,
              cùng nhau trưởng thành và học cách thấu hiểu, bao dung.
            </p>
            <p className="wedding-text-animate">
              Người ấy sẽ khiến bạn mỉm cười mỗi ngày, dù chỉ là những điều nhỏ
              bé nhất. Họ là người luôn ở bên bạn trong những khoảnh khắc buồn
              vui, là điểm tựa vững chắc khi bạn cần. Tình yêu đúng người mang
              đến cảm giác an toàn, hạnh phúc và niềm tin vào tương lai.
            </p>
            <p className="wedding-text-animate">
              Khi yêu đúng người, cuộc sống của bạn sẽ tràn ngập tiếng cười và
              những khoảnh khắc đáng trân trọng, bởi vì bạn biết rằng, dù thế
              nào đi nữa, bạn cũng không cô đơn trên hành trình này.
            </p>
            <div className="wedding-date-container">
              <h4 className="wedding-heart-title wedding-text-animate">
                <span className="wedding-heart-left">❤️</span>
                April 5th, 2025, We Said Yes!
                <span className="wedding-heart-right">❤️</span>
              </h4>
            </div>
            <p className="wedding-text-animate">
              Câu hứa hẹn đến hôn nhân không chỉ là lời nói, mà là lời cam kết
              từ trái tim. Đó là lời hứa về một tương lai cùng nhau xây dựng,
              nơi cả hai sẽ sát cánh bên nhau qua mọi thăng trầm của cuộc sống.
              Lời hứa ấy mang theo sự tin tưởng, trách nhiệm và tình yêu chân
              thành. Nó không phải là điều xa xôi, mà là mục tiêu mà cả hai cùng
              hướng đến, từng ngày một. Khi lời hứa được thực hiện, hôn nhân sẽ
              là bến đỗ bình yên, nơi tình yêu được nuôi dưỡng và trưởng thành
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Story;
